import { useCallback } from 'react';

const RECAPTCHA_SITE_KEY = '6LcxR54sAAAAAAox8j86dxJjY8P9Dm2d15p6aQZj';

function loadScript() {
  return new Promise((resolve) => {
    if (window.grecaptcha) { resolve(); return; }
    const existing = document.getElementById('recaptcha-v3');
    if (existing) { existing.addEventListener('load', resolve); return; }
    const script = document.createElement('script');
    script.id = 'recaptcha-v3';
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.onload = resolve;
    document.head.appendChild(script);
  });
}

export default function useRecaptcha() {
  const execute = useCallback(async (action = 'submit') => {
    try {
      await loadScript();
      if (!window.grecaptcha) return null;
      await new Promise(resolve => window.grecaptcha.ready(resolve));
      return await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action });
    } catch {
      return null;
    }
  }, []);

  return { execute };
}
